/*
 * Where: src/pages/HowToUsePage.js
 * What: How-to-use page component (howtouse.html route).
 * Why: Render operational guidance for service usage.
 */
import React from 'react';
import { HOW_TO_USE_HERO, HOW_TO_USE_STEPS } from '../constants/howToUseContent';
import HowToUseHeroSection from '../features/howtouse/components/HowToUseHeroSection';
import HowToUseStepsSection from '../features/howtouse/components/HowToUseStepsSection';

function HowToUsePage() {
    return (
        <>
            <HowToUseHeroSection hero={HOW_TO_USE_HERO} />
            <HowToUseStepsSection steps={HOW_TO_USE_STEPS} />
        </>
    );
}

export default HowToUsePage;
